import type { PostHog } from "posthog-js";

const PRODUCTION_ANALYTICS_HOSTS = new Set([
  "myteengig.com",
  "www.myteengig.com",
]);

type PostHogConfigInput = {
  projectToken?: string;
  host?: string;
  appHostname?: string;
  enabledOverride?: string;
};

export const shouldEnablePostHog = ({
  projectToken,
  host,
  appHostname,
  enabledOverride,
}: PostHogConfigInput): boolean => {
  if (!projectToken?.trim() || !host?.trim()) {
    return false;
  }

  const normalizedOverride = enabledOverride?.trim().toLowerCase();
  if (normalizedOverride === "true") {
    return true;
  }
  if (normalizedOverride === "false") {
    return false;
  }

  return PRODUCTION_ANALYTICS_HOSTS.has(appHostname?.toLowerCase() ?? "");
};

const noop = () => undefined;

export const disabledPostHogClient = {
  capture: noop,
  captureException: noop,
  identify: noop,
  reset: noop,
} as unknown as PostHog;
